<app-alert type="warning" [closeable]="false">
  {{ 'meteringpoint.source.remove.description' | translate }}
</app-alert>

<div class="mt-4">
  <app-table [config]="tableConfig" [data]="elements"></app-table>
</div>
